import React, { useEffect } from 'react';
import { isMobile } from 'react-device-detect';

import NavbarUnloggedDesktop from './components/NavbarUnloggedDesktop/NavbarUnloggedDesktop';

const NavbarUnlogged = ({ isHomepage, isLoginPage, isSignupPage, isErrorPage }) => {
  useEffect(() => {
    const rootElem = document.getElementById('root');

    rootElem.classList.add('-no-vertical-menu');
  }, []);

  return (
    <>
      <div className="navbar navbar-unlogged">
        {!isMobile && (
          <NavbarUnloggedDesktop
            isHomepage={isHomepage}
            isLoginPage={isLoginPage}
            isSignupPage={isSignupPage}
            isErrorPage={isErrorPage}
          />
        )}
      </div>
    </>
  );
};

export default React.memo(NavbarUnlogged);
